var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatsGray({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.77778 10.2353H22.2222M9.77778 16.8235H19.1111M25.3333 2C26.571 2 27.758 2.52059 28.6332 3.44724C29.5083 4.37389 30 5.6307 30 6.94118V20.1176C30 21.4281 29.5083 22.6849 28.6332 23.6116C27.758 24.5382 26.571 25.0588 25.3333 25.0588H17.5556L9.77778 30V25.0588H6.66667C5.42899 25.0588 4.242 24.5382 3.36684 23.6116C2.49167 22.6849 2 21.4281 2 20.1176V6.94118C2 5.6307 2.49167 4.37389 3.36684 3.44724C4.242 2.52059 5.42899 2 6.66667 2H25.3333Z",
    stroke: "#B8B8B8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatsGray);
export default __webpack_public_path__ + "static/media/chatsGray.0d8030460ad30adcc4d4b995a7d91b27.svg";
export { ForwardRef as ReactComponent };